export default function DashboardHeader({ user, title }) {
  return (
    <div className="dashboard-header">
      {/* <div className="user-info">
        <div className="user-avatar">{(user?.name || '?').charAt(0).toUpperCase()}</div>
        <div className="user-details">
          <h3>{user?.name}</h3>
          <p>{user?.email} • Trainee</p>
        </div>
      </div> */}
      <h1 className="dashboard-title">{title || 'Training Dashboard'}</h1>
    </div>
  );
}
